import { useContext, useMemo } from 'react';
import { useFormikContext } from 'formik';
import { WidgetContext } from './WidgetContext';
import { CreatWidgetFormValues } from './dashboard-widget-model';
import { useApplyCustomWords } from '../useCustomWords';

export const useWidgetContextForm = () => {
  const { programs, activityTags, reportFields, roles } = useContext(WidgetContext);
  const { values } = useFormikContext<CreatWidgetFormValues>();
  const cw = useApplyCustomWords();

  const activities = useMemo(() => {
    let activityOptions = [];
    if (values.programIds === null || values.programIds.length === 0) {
      activityOptions = programs.flatMap((p) => p.activities).map((a) => ({ value: a.activityId, label: a.name }));
    } else {
      activityOptions = programs
        .filter((p) => values.programIds.includes('all') || values.programIds.includes(p.programId))
        .flatMap((p) => p.activities)
        .map((a) => ({ value: a.activityId, label: a.name }));
    }

    return activityOptions.concat([
      {
        label: cw('All activities'),
        value: 'all',
      },
      {
        label: cw('None of activities'),
        value: 'none',
      },
    ]);
  }, [values.programIds, programs, cw]);

  const programOptions = programs
    .map((p) => ({ value: p.programId, label: p.name }))
    .concat([
      {
        label: cw('All programs'),
        value: 'all',
      },
      {
        label: cw('None of programs'),
        value: 'none',
      },
    ]);

  const activityTagOptions = activityTags
    .map((at) => ({ value: at.activityTagId, label: at.name }))
    .concat([
      {
        label: cw('All activity tags'),
        value: 'all',
      },
      {
        label: cw('None of activity tags'),
        value: 'none',
      },
    ]);

  const reportFieldsOptions = reportFields
    .map((rf) => ({ value: rf.fieldId, label: rf.name }))
    .concat([
      {
        label: 'All report fields',
        value: 'all',
      },
      {
        label: 'None of report fields',
        value: 'none',
      },
    ]);

  const roleOptions = roles.map((role) => ({ value: role.activityRoleId, label: role.name }));

  return {
    roles: roleOptions,
    programs: programOptions,
    activityTags: activityTagOptions,
    activities,
    reportFields: reportFieldsOptions,
  };
};
